module.exports = __webpack_public_path__ + "img/178.56665887.jpg";